import { render, staticRenderFns } from "./CategoryMenuItem.vue?vue&type=template&id=760aebd4&scoped=true&"
import script from "./CategoryMenuItem.vue?vue&type=script&lang=js&"
export * from "./CategoryMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./CategoryMenuItem.vue?vue&type=style&index=0&id=760aebd4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760aebd4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListItem,VListItemIcon,VListItemTitle})
